// UserItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Avatar from '../../../common/common/avatar/avatar.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class UserItem extends Component {
  static get propTypes () {
    return {
      user: PropTypes.object,
      onView: PropTypes.func,
      onSettings: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      user: {},
      onView: null,
      onSettings: null
    }
  }

  render () {
    const { user, onSettings } = this.props
    const isInvitedStatus = user.status === 'invited'
    const invitedStatusMessage = <IntlMessage ident='setting.userList.invitedStatus' />

    return (
      <div className='user-item'>
        <div className='useritem-content'>
          <div className='colavatar'>
            <Avatar imageUrl={user.imageUrl} />
          </div>
          <div className='itemhover'>
            <IconButton
              size='small'
              icon='common-action-setting'
              onClick={onSettings}
            />
          </div>
          <div className='colinfo' onClick={this._onClickView.bind(this)}>
            <div className='username'>{user.displayName}</div>
            <div className='userrole'>{user.roleType}</div>
            {isInvitedStatus ? <div className='userstatus'>{invitedStatusMessage}</div> : ''}
          </div>
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onClickView (e) {
    e.preventDefault()

    if (this.props.onView) {
      this.props.onView(this.props.user)
    }
  }
}

export default UserItem
